import { render, staticRenderFns } from "./AddFlexItemModal.vue?vue&type=template&id=484cd2d9&scoped=true&"
import script from "./AddFlexItemModal.vue?vue&type=script&lang=js&"
export * from "./AddFlexItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484cd2d9",
  null
  
)

export default component.exports